'use strict';
module.exports = require('./Accordion.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/accordion/index.js
// module id = 1521
// module chunks = 1